import { render, staticRenderFns } from "./SystemList.vue?vue&type=template&id=67e7f6d0&scoped=true&"
import script from "./SystemList.vue?vue&type=script&lang=js&"
export * from "./SystemList.vue?vue&type=script&lang=js&"
import style0 from "./SystemList.vue?vue&type=style&index=0&id=67e7f6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e7f6d0",
  null
  
)

export default component.exports